import { __extends } from "tslib";
import { each, isDate, isNil, isNumber, isString } from '@antv/util';
import { timeFormat, toTimeStamp } from '../util/time';
import Linear from './linear';
/**
 * æ¶é´åº¦é
 * @class
 */
var Time = /** @class */ (function (_super) {
    __extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'time';
        return _this;
    }
    /**
     * @override
     */
    Time.prototype.getText = function (value, index) {
        var numberValue = this.translate(value);
        var formatter = this.formatter;
        return formatter ? formatter(numberValue, index) : timeFormat(numberValue, this.mask);
    };
    /**
     * @override
     */
    Time.prototype.scale = function (value) {
        var v = value;
        if (isString(v) || isDate(v)) {
            v = this.translate(v);
        }
        return _super.prototype.scale.call(this, v);
    };
    /**
     * å°æ¶é´è½¬æ¢ææ°å­
     * @override
     */
    Time.prototype.translate = function (v) {
        return toTimeStamp(v);
    };
    Time.prototype.initCfg = function () {
        this.tickMethod = 'time-pretty';
        this.mask = 'YYYY-MM-DD';
        this.tickCount = 7;
        this.nice = false;
    };
    Time.prototype.setDomain = function () {
        var values = this.values;
        // æ¯å¦è®¾ç½®äº min, maxï¼èä¸æ¯ç´æ¥å this.min, this.max
        var minConfig = this.getConfig('min');
        var maxConfig = this.getConfig('max');
        // å¦æè®¾ç½®äº min,max åè½¬æ¢ææ¶é´æ³
        if (!isNil(minConfig) || !isNumber(minConfig)) {
            this.min = this.translate(this.min);
        }
        if (!isNil(maxConfig) || !isNumber(maxConfig)) {
            this.max = this.translate(this.max);
        }
        // æ²¡æè®¾ç½® min, max æ¶
        if (values && values.length) {
            // éæ°è®¡ç®æå¤§æå°å¼
            var timeStamps_1 = [];
            var min_1 = Infinity; // æå°å¼
            var secondMin_1 = min_1; // æ¬¡å°å¼
            var max_1 = 0;
            // ä½¿ç¨ä¸ä¸ªå¾ªç¯ï¼è®¡ç®min,max,secondMin
            each(values, function (v) {
                var timeStamp = toTimeStamp(v);
                if (isNaN(timeStamp)) {
                    throw new TypeError("Invalid Time: " + v + " in time scale!");
                }
                if (min_1 > timeStamp) {
                    secondMin_1 = min_1;
                    min_1 = timeStamp;
                }
                else if (secondMin_1 > timeStamp) {
                    secondMin_1 = timeStamp;
                }
                if (max_1 < timeStamp) {
                    max_1 = timeStamp;
                }
                timeStamps_1.push(timeStamp);
            });
            // å­å¨å¤ä¸ªå¼æ¶ï¼è®¾ç½®æå°é´è·
            if (values.length > 1) {
                this.minTickInterval = secondMin_1 - min_1;
            }
            if (isNil(minConfig)) {
                this.min = min_1;
            }
            if (isNil(maxConfig)) {
                this.max = max_1;
            }
        }
    };
    return Time;
}(Linear));
export default Time;
//# sourceMappingURL=time.js.map